<template>
  <div>
    <div class="breadcrumb">
      <h1 v-if="clickRedeem" style="color: #AC8400;">Charity</h1>
      <h1 v-else style="color: #AC8400;">Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link :to="{ name: 'charity-view' }">Charity</router-link>
      /
      <b>Redeemed Item List</b>
    </div>
    <!-- End of breadcrumbs -->
    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <button
          class="btn btn-primary"
          @click="print"
          :class="{ 'd-none': clickRedeem }"
        >
          Print
        </button>
      </div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-active"
            :class="{ 'change-background': clickRedeem }"
            @click="redeemedClick"
            type="button"
          >
            Redeemed
          </button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            :class="{ 'change-background': !clickRedeem }"
            @click="reportClick"
            type="button"
          >
            Report
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12"></div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group"></div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- <p>Add new banner and company detail to be shown on Takaful Brunei Mobile App</p> -->

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class>
              <h4 class="card-title mb-3">{{ charity.name }}</h4>

              <!-- Active -->
              <div v-if="clickRedeem" class="table-responsive">
                <table
                  id="active_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Transaction ID</th>
                      <th>Redeemed By</th>
                      <th>Points Redeemed</th>
                      <th>Price Redeemed</th>
                      <th>Donated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list, index) in donations" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ list.transaction_id }}</td>
                      <td>
                        <span v-if="list.user.deleted_at == null">
                        <router-link :to="goTo(list.user.ic_number)">{{
                          list.user.referral_id
                        }}</router-link>
                        </span>
                        
                        <span v-else>
                          {{list.user.referral_id}}
                        </span>
                      </td>
                      <td>{{ list.points }}</td>
                      <td>$ {{ list.price }}</td>
                      <td>{{ list.donated_at }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-else>
                <div class="row mb-3">
                  <div class="col-12 col-lg-6 col-sm-12"></div>

                  <div
                    class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
                  >
                    <span class="m-auto"></span>
                    <!-- Year -->
                    <div class="col-6">
                      <div class="form-group">
                        <label>Year</label>
                        <select class="form-control" v-model="filter_year">
                          <option v-for="(year, index) in years" :key="index">{{
                            year
                          }}</option>
                        </select>
                      </div>

                      <div class="form-group">
                        <button class="btn btn-primary" @click="applyFilter()">
                          Filter
                        </button>
                        &nbsp;
                        <button
                          id="btnAll"
                          class="btn btn-primary d-none"
                          @click="removeFilter()"
                        >
                          All
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="printGraph">
                  <h4 class="text-center">
                    <b>Total Redeemed For {{ charity.name }} For {{ year }}</b>
                  </h4>
                  <GChart
                    type="ColumnChart"
                    :data="columnData"
                    :options="columnOptions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  name: "charity-redeem-list",
  components: { GChart },

  data() {
    return {
      donations: [],
      charity: [],
      columnData: [],
      chart: [],

      columnOptions: {
        title: "",
        height: 600,
        legend: "bottom",
        vAxis: { title: "Total Price Redeemed ($)" },
        hAxis: { title: "Month" }
      },

      clickRedeem: true,

      year: 0,
      years: [],
      filter_year: ""
    };
  },

  methods: {
    async loadData() {
      if (!this.checkToken()) {
        return;
      }

      let id = this.$route.params.id;

      try {
        let result = await axios.get(
          axios.lpsURL + "/donation?charity_id=" + id,
          {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          }
        );
        this.charity = result.data.charity;
        this.donations = result.data.donations;
      } catch (error) {
        console.log(error);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    createDatatable() {
      $("#active_tbl").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          }
        ]
      });
    },

    goTo(ic_no) {
      return "/customer/" + ic_no;
    },

    redeemedClick() {
      (this.clickRedeem = true),
        setTimeout(() => {
          this.createDatatable();
        }, 50);
    },

    reportClick() {
      this.clickRedeem = false;
    },

    loadGraph() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;
      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(
            axios.lpsURL + "/point/redeem/charity/demographic?entity_id=" + id,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.allData = res.data;
            this.columnData = this.allData.Bar_Chart;
          });
      }
    },

    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    loadYearFilter() {
      let date = new Date();
      let start_date = 2020;
      let current_year = date.getFullYear();

      this.year = current_year;

      // Past 5 year
      for (let i = start_date; i < current_year + 1; i++) {
        this.years.push(i);
      }
    },

    removeFilter() {
      $("#btnAll").addClass("d-none");

      this.filter_year = "";
      this.years = [];

      this.loadYearFilter();

      this.loadData();
    },

    applyFilter() {
      $("#btnAll").removeClass("d-none");

      // Declare filters
      let year = "";

      let id = this.$route.params.id;
      if (this.filter_year.length != 0) {
        year = "&filter_year=" + this.filter_year;
        this.year = this.filter_year;
      }

      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(
            axios.lpsURL +
              "/point/redeem/charity/demographic?entity_id=" +
              id +
              year,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.columnData = res.data.Bar_Chart;
          });
      }
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    await this.loadData();
    this.loadYearFilter();
    this.loadGraph();
    this.createDatatable();
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
